<template>
    <transition name="fade">
        <div v-if="show" class="alert alert-warning" style="margin-top: 30px">
            <button v-if="btnClose" type="button" class="close"
                    @click="closeMe()"><span aria-hidden="true">&times;</span></button>
            <div v-if="obj">
                <ul>
                    <li v-for="lbl in label">
                        <span class="glyphicon glyphicon-info-sign" aria-valuemin="true"></span> {{ lbl }}
                    </li>
                </ul>
            </div>
            <div v-else>
                <span class="glyphicon glyphicon-info-sign" aria-valuemin="true"></span> {{ label }}
            </div>
        </div>
    </transition>
</template>

<script>
    let warningTimeoutFn;
    export default {
        props: ['show', 'label', 'btnClose', 'selfclose', 'closetime'],
        data: function(){
            return {

            }
        },
        beforeUpdate: function(){
            if(this.selfclose){
                clearTimeout(warningTimeoutFn);
                this.timeSelfClose();
            }
        },
        computed: {
            obj: function(){
                if(!this.label) {
                    return false;
                }
                return (Array.isArray(this.label)) ? true : false;
            }
        },
        methods: {
            closeMe: function(){
                this.$emit('closeAlertWarning');
            },
            timeSelfClose: function () {
                let time = this.closetime;
                if (!time) {
                    time = 3000;
                }
                let that = this;
                warningTimeoutFn = setTimeout(function () {
                    that.$emit('closeAlertWarning');
                }, time);
            }
        }
    }
</script>

<style scoped>
    ul {
        padding: 0;
        list-style: none;
    }
</style>


// WEBPACK FOOTER //
// BanetWarning.vue?007afcf6